<script setup>
defineProps({
  selected: {
    type: Boolean,
    default: false
  }
})
</script>
<template>
<svg width="26" height="10" viewBox="-3 -3 31 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.1354 8.08809L19.8865 6.18887H22.0553L21.026 3.30754L22.3133 0.0524597L26 9.84156H23.2812L22.651 8.08809H19.1354Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
<path d="M16.8157 9.84156L20.7624 0.0524597H18.1462L15.4461 6.37828L13.5261 0.0524597H11.5147L9.45345 6.37828L7.99958 3.49594L6.68384 7.54879L8.01989 9.84156H10.595L12.4577 4.16879L14.235 9.84156H16.8157Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
<path d="M2.48371 6.48086H4.09551C4.53564 6.48704 4.9745 6.43219 5.39957 6.31785L5.81648 5.03359L6.9814 1.44437C6.89187 1.30272 6.78991 1.16931 6.67672 1.04574C6.07953 0.383553 5.20474 0.0524597 4.05234 0.0524597H0V9.84156H2.48371V6.48086ZM4.61652 2.30461C4.85012 2.53956 4.96691 2.85423 4.96691 3.24863C4.96691 3.64303 4.86434 3.95805 4.65918 4.19367C4.43405 4.45232 4.01934 4.58164 3.41504 4.58164H2.48371V1.95168H3.42215C3.98447 1.95168 4.38276 2.06932 4.61703 2.30461H4.61652Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
</svg>
</template>